import React, { ReactNode } from 'react'
import { Tooltip } from 'common/Tooltip/Tooltip'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

interface FreemiumTooltippedProps {
  label: string
  children: ReactNode
}

export const FreemiumTooltipped = ({ label, children }: FreemiumTooltippedProps): React.ReactElement => {
  const workspace = useCurrentWorkspace()
  if (workspace?.is_ap_freemium) {
    return (
      <Tooltip label={label} placement="top">
        {children}
      </Tooltip>
    )
  }

  return <>{children}</>
}
